import React from 'react';

import { Button } from '@/design-system/button';
import { FormModal } from '@/design-system/form-modal';
import { RefreshDispatchStrategy } from '@/services/api/dispatches';

interface RefreshDispatchModalProps {
  isOpen: boolean;
  onClose: () => void;
  submitting: boolean;
  onSubmit: (strategy: RefreshDispatchStrategy) => Promise<void>;
}

/**
 * Pull hub arrivals into a PREVIEW dispatch (§D12). Only APPEND_NEW: new
 * arrivals come in as fresh batches and every existing batch + manual tuning
 * stays intact. (The destructive full re-plan / REPLACE_ALL option was removed
 * from the UI; the endpoint still supports it, we just never send it here.)
 */
const RefreshDispatchModal: React.FC<RefreshDispatchModalProps> = ({
  isOpen,
  onClose,
  submitting,
  onSubmit,
}) => {
  return (
    <FormModal
      open={isOpen}
      onClose={onClose}
      icon={<i className="ri-refresh-line" />}
      iconTone="primary"
      title="Tarik barang baru"
      subtitle="Masukkan barang yang tiba di hub setelah preview ini dibuat ke dalam rencana dispatch."
      size="md"
      closeOnBackdropClick={!submitting}
      closeOnEscape={!submitting}
      footer={
        <div className="flex items-center justify-end gap-2 w-full">
          <Button tone="neutral" style="stroke" onClick={onClose} disabled={submitting}>
            Batal
          </Button>
          <Button
             onClick={() => onSubmit('APPEND_NEW')}
            disabled={submitting}
          >
            {submitting ? 'Memproses…' : 'Tarik barang baru'}
          </Button>
        </div>
      }
    >
      <div className="rounded-lg border border-stroke-soft-200 bg-bg-weak-50 px-3 py-2.5">
        <p className="text-[13px] font-semibold text-text-strong-950 tracking-tight">
          Tambahkan barang baru saja
        </p>
        <p className="mt-0.5 text-[12px] text-text-sub-600 leading-relaxed">
          Hanya barang yang belum ada di dispatch ini yang direncanakan, masuk
          sebagai batch baru. Batch yang sudah ada dan semua penyesuaian
          (reassign, transfer, defer) tetap utuh.
        </p>
      </div>
    </FormModal>
  );
};

export default RefreshDispatchModal;
